import { makeStyles } from "@mui/styles";
import main_bg from "assets/images/background/main_background.png";

const useStyles = makeStyles(() => ({
  root: {
    margin: "0 auto",
    maxWidth: 500,
  },
  container: {
    position: "relative",
    height: "100dvh",
    boxShadow: "2px 4px 12px rgba(63,64,73,.1)",
    overflow: "hidden",
  },
  header: {
    position: "sticky",
    padding: "0 14px",
    backgroundColor: "#fff",
    top: 0,
    zIndex: 999,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(to right, #344EF0, #041A80)",
      clipPath: "polygon(0% 0%, 100% 0, 100% 93%, 50% 99%, 0 93%)",
      // mixBlendMode: "overlay",
      zIndex: -1,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `url(${main_bg})`,
      backgroundBlendMode: "screen",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      clipPath: "polygon(0% 0%, 100% 0, 100% 93%, 50% 100%, 0 93%)",
      zIndex: -1,
    },
  },
  tenantName: {
    "&.MuiTypography-root": {
      display: "-webkit-box",
      // fontSize: "clamp(16px, 2vw, 24px)",
      fontWeight: 600,
      color: "#ffffff",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: 1.2,
      whiteSpace: "normal",
      width: "calc(100% - 36px)",
      textAlign: "center",
      transition: "all 0.25s ease-in-out",
    },
  },
  stepper: {
    position: "relative",
    width: "100%",
    height: 80,
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    justifyContent: "center",
    "&::after": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: 6,
      backgroundColor: "#F6F6F6",
      bottom: "10%",
      zIndex: 1,
    },
  },
  contentBox: {
    height: "calc(100% - 190px)",
    margin: "0 14px",
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    boxShadow: "0px 0px 11px 0px #919EAB3D",
    backgroundColor: "#fff",
    overflow: "auto",
    paddingBottom: 14,
  },
  tab: {
    padding: "6px 0",
    fontSize: "14px !important",
    cursor: "pointer",
  },
  submittedBox: {
    width: "100%",
    height: 80,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  bottomBox: {
    position: "absolute",
    width: "calc(100% - 48px)",
    left: 0,
    bottom: 0,
    padding: "14px 24px",
    borderRadius: "0 0 12px 12px",
    backgroundColor: "#fff",
    boxShadow: "0px -4px 8px 0px #919EAB3D",
  },
  backButton: {
    "&.MuiButton-root": {
      width: "100%",
      color: "#077A20",
      fontWeight: 700,
      fontSize: 18,
      borderColor: "#077A20",
      padding: 14,
      borderRadius: 99,
    },
  },
}));

export { useStyles };
